import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

interface Props {
  checked: boolean;
  content: string;
  name: string;
  onChange: () => void;
  required?: boolean;
  showWarning?: boolean;
  warningVisible?: boolean;
}

const CollapsibleConsent: React.FC<Props> = ({
  checked,
  content,
  name,
  onChange,
  required,
  showWarning,
  warningVisible,
}) => {
  const { t } = useTranslationWithPrefix('consents');
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = (e: React.FormEvent) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const shouldShowWarning = showWarning && warningVisible && !checked;

  return (
    <div className="flex flex-col gap-1">
      <label className="flex flex-1 items-start gap-2 font-normal max-w-(--breakpoint-md) lg:max-w-(--breakpoint-lg) ">
        <Form.Check
          checked={checked}
          id={name}
          onChange={onChange}
          required={required}
          type="checkbox"
        />

        <p
          className={`small ${isExpanded ? '' : 'text-truncate'} ${shouldShowWarning ? 'text-primary' : ''}`}
        >
          {content}
          <Button className="btn btn-link pl-2" onClick={toggleExpansion}>
            <span className="small pl-2">[{t('collapse')}]</span>
          </Button>
        </p>
        {isExpanded ? (
          <> </>
        ) : (
          <>
            <Button className="btn btn-link" onClick={toggleExpansion}>
              <span className="small pl-2">[{t('expand')}]</span>
            </Button>
          </>
        )}
      </label>
      {shouldShowWarning && <p className="small text-primary ml-6">{t('warningNoConsent')}</p>}
    </div>
  );
};

export default CollapsibleConsent;
